import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    FormControl,
    FormControlLabel,
    InputLabel,
    MenuItem,
    Modal,
    Radio,
    RadioGroup,
    Select,
    TextField,
    Typography,
} from '@mui/material';
import Nlayout from './Nlayout';
import axios from 'axios';

const API_KEY = process.env.REACT_APP_PANEL_API_KEY || process.env.REACT_APP_INTERNAL_API_KEY || 'ed_qatar_2022_messi_dengueclarasoluna_2026';
const API_HEADERS = {
    'x-internal-api-key': API_KEY,
    'x-api-key': API_KEY,
};

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 380,
    bgcolor: 'background.paper',
    borderRadius: '10px',
    boxShadow: 24,
    p: 4,
};

function EnviarPush() {
    const [titulo, setTitulo] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [destinatario, setDestinatario] = useState('todos');
    const [nombreUsuario, setNombreUsuario] = useState('');
    const [usuarios, setUsuarios] = useState([]);
    const [busqueda, setBusqueda] = useState('');
    const [stats, setStats] = useState(null);
    const [resultado, setResultado] = useState('');
    const [modalAbierto, setModalAbierto] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        axios.get('https://backend.eldenguee.com/notificaciones/push-stats', { headers: API_HEADERS })
            .then((res) => setStats(res.data))
            .catch((err) => console.error('Error push-stats:', err));

        axios.get('https://backend.eldenguee.com/solicitudes/usuarios', { headers: API_HEADERS })
            .then((res) => setUsuarios(res.data || []))
            .catch((err) => console.error('Error usuarios:', err));
    }, []);

    const usuariosFiltrados = usuarios.filter((u) =>
        (u.nombre || '').toLowerCase().includes(busqueda.toLowerCase())
    );

    const puedeEnviar =
        titulo.trim() &&
        mensaje.trim() &&
        (destinatario === 'todos' || nombreUsuario.trim());

    const handleEnviar = async () => {
        setLoading(true);
        setResultado('');
        try {
            const res = await axios.post(
                'https://backend.eldenguee.com/notificaciones/enviar-push',
                {
                    titulo: titulo.trim(),
                    mensaje: mensaje.trim(),
                    destinatario,
                    nombre: destinatario === 'usuario' ? nombreUsuario.trim() : undefined,
                    guardarInbox: true,
                },
                { headers: API_HEADERS }
            );
            const d = res.data;
            setResultado(
                `${d.mensaje} Enviados: ${d.enviados}` +
                (d.erroresPush ? ` · Errores: ${d.erroresPush}` : '') +
                (d.guardadas ? ` · Guardadas en inbox: ${d.guardadas}` : '')
            );
            setModalAbierto(false);
            setTitulo('');
            setMensaje('');
            axios.get('https://backend.eldenguee.com/notificaciones/push-stats', { headers: API_HEADERS })
                .then((r) => setStats(r.data))
                .catch(() => {});
        } catch (err) {
            setResultado(`Error: ${err.response?.data?.error || err.message}`);
            setModalAbierto(false);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Nlayout>
            <Box p={4}>
                <Box sx={{ p: 4, display: 'flex', flexDirection: 'column', gap: 2, maxWidth: 480 }}>
                    <Typography sx={{
                        background: 'linear-gradient(180deg,#fff -31.86%,#a8a6af 132.28%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        fontWeight: 'bold',
                        fontSize: 48,
                        fontFamily: 'PoetsenOne',
                        lineHeight: 1.1,
                    }}>
                        Enviar Push
                    </Typography>

                    <Typography sx={{ color: 'rgba(255,255,255,0.65)', fontSize: 14 }}>
                        Enviá notificaciones push a la app. También se guardan en el inbox del usuario.
                    </Typography>

                    {stats && (
                        <Box sx={{
                            p: 2,
                            borderRadius: 2,
                            border: '1px solid rgba(255,255,255,0.12)',
                            background: 'rgba(255,255,255,0.04)',
                        }}>
                            <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: 13, mb: 0.5 }}>
                                Dispositivos
                            </Typography>
                            <Typography sx={{ color: '#93c5fd', fontSize: 22, fontWeight: 800, fontFamily: 'PoetsenOne' }}>
                                {stats.conToken}
                                <Typography component="span" sx={{ color: 'rgba(255,255,255,0.45)', fontSize: 13, ml: 1, fontWeight: 400 }}>
                                    con push token · {stats.totalUsuarios} usuarios totales
                                </Typography>
                            </Typography>
                        </Box>
                    )}

                    <TextField
                        label="Título"
                        value={titulo}
                        onChange={(e) => setTitulo(e.target.value)}
                        fullWidth
                        inputProps={{ maxLength: 120 }}
                        InputLabelProps={{ style: { color: '#fff' } }}
                        InputProps={{ style: { color: '#fff' } }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': { borderColor: '#fff' },
                                '&:hover fieldset': { borderColor: '#ccc' },
                            },
                        }}
                    />

                    <TextField
                        label="Mensaje"
                        value={mensaje}
                        onChange={(e) => setMensaje(e.target.value)}
                        fullWidth
                        multiline
                        minRows={3}
                        inputProps={{ maxLength: 500 }}
                        InputLabelProps={{ style: { color: '#fff' } }}
                        InputProps={{ style: { color: '#fff' } }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': { borderColor: '#fff' },
                                '&:hover fieldset': { borderColor: '#ccc' },
                            },
                        }}
                    />

                    <FormControl component="fieldset">
                        <Typography sx={{ color: '#fff', fontSize: 13, mb: 0.5 }}>Destinatario</Typography>
                        <RadioGroup
                            value={destinatario}
                            onChange={(e) => setDestinatario(e.target.value)}
                        >
                            <FormControlLabel
                                value="todos"
                                control={<Radio sx={{ color: '#fff', '&.Mui-checked': { color: '#3b82f6' } }} />}
                                label={<Typography sx={{ color: '#fff', fontSize: 14 }}>Todos los usuarios con la app</Typography>}
                            />
                            <FormControlLabel
                                value="usuario"
                                control={<Radio sx={{ color: '#fff', '&.Mui-checked': { color: '#3b82f6' } }} />}
                                label={<Typography sx={{ color: '#fff', fontSize: 14 }}>Un usuario específico</Typography>}
                            />
                        </RadioGroup>
                    </FormControl>

                    {destinatario === 'usuario' && (
                        <FormControl fullWidth variant="outlined">
                            <InputLabel sx={{ color: '#fff' }}>Seleccionar Usuario</InputLabel>
                            <Select
                                value={nombreUsuario}
                                onChange={(e) => setNombreUsuario(e.target.value)}
                                label="Seleccionar Usuario"
                                MenuProps={{ PaperProps: { style: { maxHeight: 280 } } }}
                                sx={{
                                    color: '#fff',
                                    '.MuiOutlinedInput-notchedOutline': { borderColor: '#fff' },
                                    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#ccc' },
                                    '.MuiSvgIcon-root': { color: '#fff' },
                                }}
                            >
                                <MenuItem disableRipple>
                                    <TextField
                                        size="small"
                                        placeholder="Buscar..."
                                        value={busqueda}
                                        onChange={(e) => setBusqueda(e.target.value)}
                                        onClick={(e) => e.stopPropagation()}
                                        onKeyDown={(e) => e.stopPropagation()}
                                        sx={{ width: '100%', '& .MuiInputBase-input': { color: '#111' } }}
                                    />
                                </MenuItem>
                                {usuariosFiltrados.map((u, idx) => (
                                    <MenuItem key={idx} value={u.nombre}>{u.nombre}</MenuItem>
                                ))}
                                {usuariosFiltrados.length === 0 && (
                                    <MenuItem disabled>Sin resultados</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    )}

                    <Button
                        variant="contained"
                        color="primary"
                        disabled={!puedeEnviar || loading}
                        onClick={() => setModalAbierto(true)}
                    >
                        ENVIAR NOTIFICACIÓN
                    </Button>

                    {resultado && (
                        <Typography color={resultado.startsWith('Error') ? 'error.main' : 'success.main'}>
                            {resultado}
                        </Typography>
                    )}

                    <Modal open={modalAbierto} onClose={() => setModalAbierto(false)}>
                        <Box sx={modalStyle}>
                            <Typography variant="h6" gutterBottom>Confirmar envío</Typography>
                            <Typography sx={{ mb: 1 }}>
                                {destinatario === 'todos'
                                    ? <>Vas a enviar push a <strong>todos</strong> los dispositivos con token ({stats?.conToken ?? '?'}).</>
                                    : <>Vas a enviar push a <strong>{nombreUsuario}</strong>.</>}
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
                                <strong>{titulo}</strong><br />{mensaje}
                            </Typography>
                            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                                <Button onClick={() => setModalAbierto(false)}>Cancelar</Button>
                                <Button variant="contained" disabled={loading} onClick={handleEnviar}>
                                    Confirmar
                                </Button>
                            </Box>
                        </Box>
                    </Modal>
                </Box>
            </Box>
        </Nlayout>
    );
}

export default EnviarPush;
